module.exports = __webpack_public_path__ + "media/images/svgs/warning_sign_blue-66b83d861b37568a72ea4cafdf28206a.svg";